import { Component, OnInit,  ViewChild } from '@angular/core';
import { DataTableDirective } from 'angular-datatables';
import { Subject } from 'rxjs';
import { spanish } from './../../../interfaces/datatables.es';

import { IonicAngularProvider } from '../../providers/ionic-angular/ionic-angular';
import { UserProvider } from '../../providers/user/user';
import { LoanProvider } from '../../providers/loan/loan';

import * as _ from 'lodash';

@Component({
  selector: 'app-authorization-list',
  templateUrl: './authorization-list.component.html',
  styleUrls: ['./authorization-list.component.css']
})
export class AuthorizationListComponent implements OnInit {

  dtOptions: any = {
    pagingType: 'full_numbers',
    pageLength: 10,
    language: spanish,
    // Declare the use of the extension in the dom parameter
    dom: 'Blfrtip',
    /*columns: [{
      title: 'Negocio',
      data: 'business'
    }, {
      title: 'Creado por',
      data: 'created-by'
    }, {
      title: 'Fecha',
      data: 'date'
    }, {
      title: 'Pagare',
      data: 'promissory-number'
    }, {  
      title: 'Total',
      data: 'total'
    }],*/

    // Configure the buttons
    buttons: [
    
      {
        extend:'excel',
        text: 'Descargar Excel',
        className: 'btn btn-primary margin-5',
      },
      {
          text: 'Descargar CSV',
          className: 'btn btn-warning margin-5',
          extend: 'csv'
          
      }
    ],
  };
  doRerender: any = false;

  operators: any = [];
  items: any = [];
  filters: any = {
    assignedToId: null
  };
  filteredItems: any = [];

  dtTrigger: Subject<any> = new Subject();
  @ViewChild(DataTableDirective) dtElement: DataTableDirective;

  constructor(
    public IA: IonicAngularProvider,
    public userWS: UserProvider,
    public loanWS: LoanProvider,

  ) { }

  ngOnInit() {
    this.initializeView();
  }

  initializeView() {
    this.IA.showLoading();
    
    return this.userWS.getOperatorsWithCredits()
    .then((res: any) => {
      //console.log(res);
      if(res.status == 'success' && res.data) {
        this.operators = res.data;
      }

      return this.loadData();
    })
    .then(() => {
      this.filterItems();
      this.IA.hideLoading();
      return true;
    });
  }

  loadData() {
    
    return this.loanWS.getLoansByStatus(3).then((res:any )=> {
      if(res.status == 'success' && res.data) {
        this.items = res.data;
        //this.makeSegments(res.data);
      }
      return res;
    })
  }

  filterItems() {
    
    //this.filteredItems = this.currentSegment.items;
    //console.log(this.currentSegment);
    if(this.filters.assignedToId) {
      this.filters.assignedTo = _.find(this.operators, { id: parseInt(this.filters.assignedToId)});
    }
    console.log(this.filters);
    this.filteredItems = _.filter(this.items, (item) => {
      //console.log(item);
      let res = true;
      if(this.filters.assignedTo && res) {
        res = (item.assignedId && item.assignedId == this.filters.assignedTo.id) || 
        (item.assignedTo && item.assignedTo.indexOf( this.filters.assignedTo.displayName.toLowerCase()) > -1) ||
        (item.authorizedBy && item.authorizedBy.indexOf( this.filters.assignedTo.displayName.toLowerCase()) > -1) ||
        (item.createdBy && item.createdBy.indexOf( this.filters.assignedTo.displayName.toLowerCase()) > -1);
      }
      if(this.filters.searchTerm && res) {
        res = (item.businessName && item.businessName.toLowerCase().indexOf(this.filters.searchTerm.toLowerCase()) > -1) || 
        (item.businessAddress && item.businessAddress.toLowerCase().indexOf(this.filters.searchTerm.toLowerCase()) > -1) ||
        (item.businessSuburb && item.businessSuburb.toLowerCase().indexOf(this.filters.searchTerm.toLowerCase()) > -1) ||
        (item.cliente && item.cliente.toLowerCase().indexOf(this.filters.searchTerm.toLowerCase()) > -1) ||
        (item.displayName && item.displayName.toLowerCase().indexOf(this.filters.searchTerm.toLowerCase()) > -1) ||
        (item.address && item.address.toLowerCase().indexOf(this.filters.searchTerm.toLowerCase()) > -1) ||
        (item.businessPhone && item.businessPhone.toLowerCase().indexOf(this.filters.searchTerm.toLowerCase()) > -1) ||
        (item.suburb && item.suburb.toLowerCase().indexOf(this.filters.searchTerm.toLowerCase()) > -1) ||
        (item.phone && item.phone.toLowerCase().indexOf(this.filters.searchTerm.toLowerCase()) > -1) ||
        (item.promissoryNoteNumber && item.promissoryNoteNumber.toString().toLowerCase().indexOf(this.filters.searchTerm.toLowerCase()) > -1);
        
      }
      return res;
    });
    //console.log('changed', this.currentSegment, this.currentStatus);
    //console.log('current Filters', this.filters);
    console.log(this.filteredItems);
    // Calling the DT trigger to manually render the table
    if(this.doRerender) {
      this.rerender();

    } else {
      this.dtTrigger.next();
    }
    this.doRerender = true;
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }
}


// WEBPACK FOOTER //
// C:/projects/angular/DineroAgil/src/app/pages/authorization-list/authorization-list.component.ts